// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  height: calc(100% - (3.5rem + 60px + 52px + 2rem));
}

.sidebar .nav-item .nav-dropdown-items:hover .badge.badge-paylixecommerce.dropdown-beta-link {
  color: var(--purple6) !important;
}

.sidebar .nav-item .nav-dropdown-items .badge.badge-paylixecommerce.dropdown-beta-link {
  display: flex;
  gap: 0.25rem;
  color: var(--purple6);
  border: 1px solid var(--purple6);
}
.sidebar .nav-item .nav-dropdown-items .badge.badge-paylixecommerce.dropdown-beta-link:hover {
  color: var(--purple6) !important;
}

.nav-dropdown-items .sidebar-icon {
  font-size: 1rem;
  margin-right: 0;
}

.minimized .sidebar-icon {
  align-items: center;
  justify-content: center;
  display: flex;
  margin-right: 0;
}

span.sidebar-new-badge {
  display: flex;
  flex-wrap: nowrap;
}
span.sidebar-new-badge span {
  font-size: 0.6rem;
  font-weight: 900;
  padding: 6px;
  height: 20px;
  color: var(--purple6) !important;
  background-color: var(--purple1) !important;
  position: absolute;
  right: 0.5rem;
  transform: translate(0, -50%);
  top: 50%;
}

.sidebar-icon {
  width: 2rem;
  font-size: 1.01rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.25rem;
}

.sidebar {
  height: auto;
  overflow: auto;
  width: 240px;
  padding: 0.75rem 0 0 0;
  margin-bottom: 0;
  list-style: none;
  flex-direction: column;
  display: flex;
  transition: padding 0.15s ease;
}
.sidebar::-webkit-scrollbar {
  width: 2px !important;
  height: 1px !important;
}
.sidebar-container {
  position: fixed;
  z-index: 12;
  width: 240px;
  background: var(--black0);
  margin-left: 0;
  padding-top: 0;
  margin-bottom: 0;
  transition: width 0.15s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  border-right: 1px solid var(--black1);
  height: inherit;
  max-height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.sidebar-container.mobile {
  width: 100%;
}
.sidebar-container.mobile .sidebar {
  width: 100%;
}
.sidebar-container.mobile .sidebar-shops-current-data span {
  width: 100%;
}
.sidebar-container.minimized {
  width: 68px;
}
.sidebar > .nav-item#settings {
  margin-bottom: 1.5rem;
}
.sidebar > .nav-item:nth-child(5), .sidebar > .nav-item:nth-child(8), .sidebar > .nav-item:nth-child(11), .sidebar > .nav-item:nth-child(12) {
  margin-bottom: 1.5rem;
}
.sidebar > .nav-item:nth-child(5):after, .sidebar > .nav-item:nth-child(8):after, .sidebar > .nav-item:nth-child(11):after, .sidebar > .nav-item:nth-child(12):after {
  content: "";
  height: 1px;
  width: 80%;
  border-bottom: 1px solid var(--black1);
  display: flex;
  margin-left: 10%;
  position: relative;
  top: 0.75rem;
}
.sidebar .nav-item {
  width: 100%;
  padding: 0;
  position: relative;
}
.sidebar .nav-item:has(+ .nav-item:hover) .nav-link.active {
  background-color: transparent;
}
.sidebar .nav-item:hover + .nav-item .nav-link.active {
  background-color: transparent;
}
.sidebar .nav-item:hover > .nav-link {
  background: var(--black1);
  color: var(--black9);
  border-radius: 0.5rem;
}
.sidebar .nav-item:hover > .nav-link svg * {
  stroke: var(--black9);
}
.sidebar .nav-item:hover > .nav-link span {
  color: var(--black9);
}
.sidebar .nav-item .nav-link {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem;
  position: relative;
  margin: 0 1rem 0 1rem;
  color: var(--black5) !important;
}
.sidebar .nav-item .nav-link:focus {
  outline: none;
}
.sidebar .nav-item .nav-link + .nav-dropdown-items.open {
  max-height: 400px;
}
.sidebar .nav-item .nav-link .sidebar-icon {
  width: 1rem;
  margin-right: 0;
}
.sidebar .nav-item .nav-link span {
  margin-left: 1rem;
  opacity: 1;
  transition: opacity 0.15s ease;
  color: var(--black5);
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
}
.sidebar .nav-item .nav-link.active {
  position: relative;
  cursor: pointer;
  background: var(--black1);
  border-radius: 0.5rem;
}
.sidebar .nav-item .nav-link.active.has-dropdown {
  background: transparent;
}
.sidebar .nav-item .nav-link.active.has-dropdown.active svg * {
  stroke: var(--black9);
}
.sidebar .nav-item .nav-link.active span {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: var(--black9);
}
.sidebar .nav-item .nav-dropdown-items-minimized {
  transition: none !important;
}
.sidebar .nav-item .nav-dropdown-items, .sidebar .nav-item .nav-dropdown-items-minimized {
  list-style: none;
  max-height: 0;
  padding: 0;
  overflow: hidden;
  transition: all 0.15s linear;
}
.sidebar .nav-item .nav-dropdown-items .nav-item, .sidebar .nav-item .nav-dropdown-items-minimized .nav-item {
  padding: 0 0;
  margin-bottom: 0;
  position: relative;
  cursor: pointer;
}
.sidebar .nav-item .nav-dropdown-items .nav-link, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link {
  font-size: 14px;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  cursor: pointer;
  border-radius: 0.5rem !important;
}
.sidebar .nav-item .nav-dropdown-items .nav-link span, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link span {
  margin-left: 0.5rem;
  transition: opacity 0.15s ease;
}
.sidebar .nav-item .nav-dropdown-items .nav-link .sidebar-new-badge span, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link .sidebar-new-badge span {
  border: 1px solid var(--purple6);
  font-size: 12px;
}
.sidebar .nav-item .nav-dropdown-items .nav-link.active, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link.active {
  border-radius: 0.25rem;
}
.sidebar .nav-item .nav-dropdown-items .nav-link.active.has-dropdown, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link.active.has-dropdown {
  background: var(--black1);
}
.sidebar .nav-item .nav-dropdown-items .nav-link.active:hover span, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link.active:hover span {
  color: var(--black5) !important;
}
.sidebar .nav-item .nav-dropdown-items .nav-link div svg path, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link div svg path {
  stroke: var(--purple6);
}
.sidebar .nav-item .nav-dropdown-items .nav-link:hover, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link:hover {
  background: var(--black1);
}
.sidebar .nav-item .nav-dropdown-items .nav-link:hover span, .sidebar .nav-item .nav-dropdown-items-minimized .nav-link:hover span {
  color: var(--black9);
}
.sidebar .nav-item .nav-dropdown-items-minimized {
  display: none;
}
.sidebar.minimized {
  overflow: visible;
  width: 68px;
  padding: 1rem 0 0 0;
}
.sidebar.minimized > .nav-item:nth-child(5), .sidebar.minimized > .nav-item:nth-child(7), .sidebar.minimized > .nav-item:nth-child(9) {
  margin-bottom: 0;
}
.sidebar.minimized > .nav-item:nth-child(5):after, .sidebar.minimized > .nav-item:nth-child(7):after, .sidebar.minimized > .nav-item:nth-child(9):after {
  display: none;
}
.sidebar.minimized > .nav-item#settings {
  margin-bottom: 1.5rem;
}
.sidebar.minimized > .nav-item:nth-child(1), .sidebar.minimized > .nav-item:nth-child(6), .sidebar.minimized > .nav-item:nth-child(8), .sidebar.minimized > .nav-item:nth-child(10) {
  margin-bottom: 1.5rem;
}
.sidebar.minimized > .nav-item:nth-child(1):after, .sidebar.minimized > .nav-item:nth-child(6):after, .sidebar.minimized > .nav-item:nth-child(8):after, .sidebar.minimized > .nav-item:nth-child(10):after {
  content: "";
  height: 1px;
  width: 50%;
  background: var(--black1);
  display: flex;
  margin-left: 25%;
  position: relative;
  top: 0.75rem;
}
.sidebar.minimized > .nav-item > .nav-link {
  height: 35px;
  width: 35px;
  justify-content: center;
  transition: all 0.15s ease;
}
.sidebar.minimized > .nav-item > .nav-link > span {
  opacity: 0;
  display: none;
}
.sidebar.minimized > .nav-item .nav-dropdown-items-minimized {
  display: none;
  max-height: initial;
  flex-direction: column;
  position: absolute;
  background: var(--white);
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0px 2px 24px -2px rgba(7, 14, 35, 0.12);
  border-radius: 0.5rem;
  min-width: 244px;
  white-space: nowrap;
  left: 60px;
  z-index: 6;
  padding: 0.5rem;
}
@media (max-height: 900px) {
  .sidebar.minimized > .nav-item .nav-dropdown-items-minimized {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
}
.sidebar.minimized > .nav-item .nav-dropdown-items-minimized.open {
  display: flex;
}
.sidebar.minimized > .nav-item .nav-dropdown-items-minimized .nav-item-title {
  padding: 1rem;
  padding-top: 0.5rem;
  color: var(--black9);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
}
.sidebar.minimized > .nav-item .nav-dropdown-items-minimized .nav-link {
  padding: 0.5rem;
  margin: 0;
}
.sidebar.minimized > .nav-item .nav-dropdown-items-minimized .nav-link:hover {
  background: var(--black1);
}
.sidebar.minimized > .nav-item .nav-dropdown-items {
  display: none;
}
.sidebar.minimized > .nav-item.nav-dropdown .nav-dropdown-items-minimized {
  display: flex;
}

.sidebar-container.minimized .nav-dropdown-items-minimized.open {
  position: fixed;
}

.sidebar-minimized {
  margin-top: 2rem;
}
.sidebar-minimized.nav-item {
  width: 100%;
  padding: 0;
  position: relative;
}
.sidebar-minimized.nav-item .nav-link {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 1rem 0 0.75rem;
  height: 35px;
  position: relative;
  margin: 0 0.5rem 0 0.75rem;
  color: var(--black5) !important;
}
.sidebar-minimized.nav-item .nav-link:focus {
  outline: none;
}
.sidebar-minimized.nav-item .nav-link + .nav-dropdown-items.open {
  max-height: 400px;
}
.sidebar-minimized.nav-item .nav-link span {
  margin-left: 0.5rem;
  opacity: 1;
  font-size: 13px;
  font-weight: 400;
  transition: opacity 0.15s ease;
  color: var(--black5);
}
.sidebar-minimized.nav-item .nav-link.active {
  position: relative;
  cursor: pointer;
  background: var(--black1);
  border-radius: 0.5rem;
}
.sidebar-minimized.nav-item .nav-link.active span {
  color: var(--white);
}
.sidebar-minimized.nav-item .nav-dropdown-items-minimized {
  transition: none !important;
}
.sidebar-minimized.nav-item .nav-dropdown-items, .sidebar-minimized.nav-item .nav-dropdown-items-minimized {
  list-style: none;
  max-height: 0;
  padding: 0;
  overflow: hidden;
  transition: all 0.15s linear;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-item, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-item {
  padding: 0 0;
  margin-bottom: 0;
  position: relative;
  cursor: pointer;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link {
  font-size: 14px;
  font-weight: 400;
  padding: 0.7rem 0 0.7rem 1.25rem;
  cursor: pointer;
  border-radius: 0.5rem !important;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link span, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link span {
  margin-left: 0.5rem;
  transition: opacity 0.15s ease;
  font-weight: 400;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link.active, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link.active {
  border-radius: 0.5rem;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link.active:hover span, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link.active:hover span {
  color: var(--black9) !important;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link.active span, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link.active span {
  color: var(--black9) !important;
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link:hover, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link:hover {
  background: var(--black1);
}
.sidebar-minimized.nav-item .nav-dropdown-items .nav-link:hover span, .sidebar-minimized.nav-item .nav-dropdown-items-minimized .nav-link:hover span {
  color: var(--black9);
}
.sidebar-minimized.nav-item .nav-dropdown-items-minimized {
  display: none;
}
@media (max-width: 768px) {
  .sidebar-minimized {
    display: none;
  }
}

.sidebar.minimized {
  width: 68px;
  overflow: auto;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/dashboard/sidebar/index.scss"],"names":[],"mappings":"AAAA;EACE,kDAAA;AACF;;AAQA;EACE,gCAAA;AALF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,gCAAA;AALF;AAOE;EACE,gCAAA;AALJ;;AASA;EACE,eAAA;EACA,eAAA;AANF;;AASA;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AANF;;AASA;EACE,aAAA;EACA,iBAAA;AANF;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,QAAA;AANJ;;AAmBA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAhBF;;AAmBA;EAEE,YAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;AAjBF;AAmBE;EACE,qBAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAlBJ;AAoBI;EACE,WAAA;AAlBN;AAoBM;EACE,WAAA;AAlBR;AAqBM;EACE,WAAA;AAnBR;AAuBI;EACE,WAAA;AArBN;AA2BI;EACE,qBAAA;AAzBN;AA4BI;EACE,qBAAA;AA1BN;AA2BM;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,sCAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAzBR;AA8BE;EACE,WAAA;EACA,UAAA;EACA,kBAAA;AA5BJ;AA+BM;EACE,6BAAA;AA7BR;AAmCQ;EACE,6BAAA;AAjCV;AAwCM;EACE,yBAAA;EACA,oBAAA;EACA,qBAAA;AAtCR;AAwCQ;EACE,qBAAA;AAtCV;AAyCQ;EACE,oBAAA;AAvCV;AA4CI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;AA1CN;AA4CM;EACE,aAAA;AA1CR;AA6CM;EACE,iBAAA;AA3CR;AA8CM;EACE,WAAA;EACA,eAAA;AA5CR;AA+CM;EACE,iBAAA;EACA,UAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7CR;AAiDM;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AA/CR;AAiDQ;EACE,uBAAA;AA/CV;AAkDY;EACE,qBAAA;AAhDd;AAqDQ;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAnDV;AAwDI;EACE,2BAAA;AAtDN;AAyDI;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;AAvDN;AAyDM;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAvDR;AA0DM;EACE,eAAA;EACA,oCAAA;EACA,eAAA;EACA,gCAAA;AAxDR;AA0DQ;EACE,mBAAA;EACA,8BAAA;AAxDV;AA4DU;EACE,gCAAA;EACA,eAAA;AA1DZ;AA8DQ;EACE,sBAAA;AA5DV;AA8DU;EACE,yBAAA;AA5DZ;AAgEY;EACE,+BAAA;AA9Dd;AAoFY;EACE,sBAAA;AAlFd;AAuFQ;EACE,yBAAA;AArFV;AAuFU;EACE,oBAAA;AArFZ;AA4FI;EACE,aAAA;AA1FN;AA+FE;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;AA7FJ;AAiGM;EACE,gBAAA;AA/FR;AAgGQ;EACE,aAAA;AA9FV;AAkGM;EACE,qBAAA;AAhGR;AAmGM;EACE,qBAAA;AAjGR;AAmGQ;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAjGV;AAqGM;EAEE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;AApGR;AA0GQ;EACE,UAAA;EACA,aAAA;AAxGV;AA6GM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yFAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AA3GR;AA6GQ;EAdF;IAeI,mBAAA;IACA,sCAAA;EA1GR;AACF;AA4GQ;EACE,aAAA;AA1GV;AA6GQ;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA3GV;AA8GQ;EACE,eAAA;EACA,SAAA;AA5GV;AA8GU;EACE,yBAAA;AA5GZ;AAiHM;EACE,aAAA;AA/GR;AAmHQ;EACE,aAAA;AAjHV;;AA6HE;EACE,eAAA;AA1HJ;;AAgIA;EACE,gBAAA;AA7HF;AA+HE;EACE,WAAA;EACA,UAAA;EACA,kBAAA;AA7HJ;AA+HI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,+BAAA;AA7HN;AA+HM;EACE,aAAA;AA7HR;AAgIM;EACE,iBAAA;AA9HR;AAiIM;EACE,mBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,oBAAA;AA/HR;AAkIM;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AAhIR;AAkIQ;EACE,mBAAA;AAhIV;AAqII;EACE,2BAAA;AAnIN;AAsII;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;AApIN;AAsIM;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AApIR;AAuIM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gCAAA;AArIR;AAuIQ;EACE,mBAAA;EACA,8BAAA;EACA,gBAAA;AArIV;AAwIQ;EACE,qBAAA;AAtIV;AAyIY;EACE,+BAAA;AAvId;AA2IU;EACE,+BAAA;AAzIZ;AA6IQ;EACE,yBAAA;AA3IV;AA6IU;EACE,oBAAA;AA3IZ;AAkJI;EACE,aAAA;AAhJN;AAoJE;EA7GF;IA8GI,aAAA;EAjJF;AACF;;AAoJA;EACI,WAAA;EACA,cAAA;EACA,YAAA;AAjJJ","sourcesContent":[".sidebar {\n  height: calc(100% - (3.5rem + 60px + 52px + 2rem));\n}\n\n#customization {\n  //@media (max-width: 768px) {\n  //  display: none;\n  //}\n}\n\n.sidebar .nav-item .nav-dropdown-items:hover .badge.badge-paylixecommerce.dropdown-beta-link {\n  color: var(--purple6) !important;\n}\n\n.sidebar .nav-item .nav-dropdown-items .badge.badge-paylixecommerce.dropdown-beta-link {\n  display: flex;\n  gap: .25rem;\n  color: var(--purple6);\n  border: 1px solid var(--purple6);\n\n  &:hover {\n    color: var(--purple6) !important;\n  }\n}\n\n.nav-dropdown-items .sidebar-icon {\n  font-size: 1rem;\n  margin-right: 0;\n}\n\n.minimized .sidebar-icon {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  margin-right: 0;\n}\n\nspan.sidebar-new-badge {\n  display: flex;\n  flex-wrap: nowrap;\n\n  span {\n    font-size: .6rem;\n    font-weight: 900;\n    padding: 6px;\n    height: 20px;\n    color: var(--purple6) !important;\n    background-color: var(--purple1) !important;\n    position: absolute;\n    right: .5rem;\n    transform: translate(0, -50%);\n    top: 50%;\n  }\n}\n\n.sidebar.minimized:hover {\n  @media (max-width: 768px) {\n    //overflow: hidden;\n  }\n  @media (min-width: 768px) {\n    //overflow: visible !important;\n  }\n}\n\n.sidebar-icon {\n  width: 2rem;\n  font-size: 1.01rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: .25rem;\n}\n\n.sidebar {\n  // header + note + shops + margin\n  height: auto;\n  overflow: auto;\n  width: 240px;\n  padding: .75rem 0 0 0;\n  margin-bottom: 0;\n  list-style: none;\n  flex-direction: column;\n  display: flex;\n  transition: padding .15s ease;\n\n  &::-webkit-scrollbar {\n    width: 2px !important;\n    height: 1px !important;\n  }\n\n  &-container {\n    position: fixed;\n    z-index: 12;\n    width: 240px;\n    background: var(--black0);\n    margin-left: 0;\n    padding-top: 0;\n    margin-bottom: 0;\n    transition: width .15s ease;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-user-drag: none;\n    border-right: 1px solid var(--black1);\n    height: inherit;\n    max-height: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    &.mobile {\n      width: 100%;\n\n      .sidebar {\n        width: 100%;\n      }\n\n      .sidebar-shops-current-data span {\n        width: 100%;\n      }\n    }\n\n    &.minimized {\n      width: 68px;\n    }\n  }\n\n  & > .nav-item {\n\n    &#settings {\n      margin-bottom: 1.5rem;\n    }\n\n    &:nth-child(5), &:nth-child(8), &:nth-child(11), &:nth-child(12) {\n      margin-bottom: 1.5rem;\n      &:after {\n        content: \"\";\n        height: 1px;\n        width: 80%;\n        border-bottom: 1px solid var(--black1);\n        display: flex;\n        margin-left: 10%;\n        position: relative;\n        top: 0.75rem;\n      }\n    }\n  }\n\n  .nav-item {\n    width: 100%;\n    padding: 0;\n    position: relative;\n\n    &:has(+ .nav-item:hover) {\n      .nav-link.active {\n        background-color: transparent;\n      }\n    }\n\n    &:hover {\n      & + .nav-item {\n        .nav-link.active {\n          background-color: transparent;\n        }\n      }\n    }\n\n    &:hover {\n\n      & > .nav-link {\n        background: var(--black1);\n        color: var(--black9);\n        border-radius: .5rem;\n\n        svg * {\n          stroke: var(--black9)\n        }\n\n        span {\n          color: var(--black9);\n        }\n      }\n    }\n\n    .nav-link {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      padding: .5rem;\n      position: relative;\n      margin: 0 1rem 0 1rem;\n      color: var(--black5) !important;\n\n      &:focus {\n        outline: none;\n      }\n\n      + .nav-dropdown-items.open {\n        max-height: 400px;\n      }\n\n      .sidebar-icon {\n        width: 1rem;\n        margin-right: 0;\n      }\n\n      span {\n        margin-left: 1rem;\n        opacity: 1;\n        transition: opacity .15s ease;\n        color: var(--black5);\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 19px;\n      }\n\n\n      &.active {\n        position: relative;\n        cursor: pointer;\n        background: var(--black1);\n        border-radius: .5rem;\n\n        &.has-dropdown {\n          background: transparent;\n\n          &.active {\n            svg * {\n              stroke: var(--black9)\n            }\n          }\n        }\n\n        span {\n          font-family: 'Inter';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 19px;\n          color: var(--black9);\n        }\n      }\n    }\n\n    .nav-dropdown-items-minimized {\n      transition: none !important;\n    };\n\n    .nav-dropdown-items, .nav-dropdown-items-minimized {\n      list-style: none;\n      max-height: 0;\n      padding: 0;\n      overflow: hidden;\n      transition: all .15s linear;\n\n      .nav-item {\n        padding: 0 0;\n        margin-bottom: 0;\n        position: relative;\n        cursor: pointer;\n      }\n\n      .nav-link {\n        font-size: 14px;\n        padding: .5rem .5rem .5rem 1.5rem;\n        cursor: pointer;\n        border-radius: .5rem !important;\n\n        span {\n          margin-left: .5rem;\n          transition: opacity .15s ease;\n        }\n\n        .sidebar-new-badge {\n          span {\n            border: 1px solid var(--purple6);\n            font-size: 12px;\n          }\n        }\n\n        &.active {\n          border-radius: .25rem;\n\n          &.has-dropdown {\n            background: var(--black1);\n          }\n\n          &:hover {\n            span {\n              color: var(--black5) !important;\n            }\n            div {\n              span {\n                //border: 1px solid var(--purple6);\n                //font-size: 12px;\n                //color: var(--purple6) !important;\n              }\n            }\n\n          }\n        }\n\n\n        & div {\n          span {\n            //border: 1px solid var(--purple6);\n            //font-size: 12px;\n            //color: var(--purple6) !important;\n          }\n\n          svg {\n            path {\n              stroke: var(--purple6);\n            }\n          }\n        }\n\n        &:hover {\n          background: var(--black1);\n\n          span {\n            color: var(--black9);\n          }\n        }\n\n      }\n    };\n\n    .nav-dropdown-items-minimized {\n      display: none;\n    }\n  };\n\n\n  &.minimized {\n    overflow: visible;\n    width: 68px;\n    padding: 1rem 0 0 0;\n\n    & > .nav-item {\n\n      &:nth-child(5), &:nth-child(7), &:nth-child(9) {\n        margin-bottom: 0;\n        &:after {\n          display: none;\n        }\n      }\n\n      &#settings {\n        margin-bottom: 1.5rem;\n      }\n\n      &:nth-child(1), &:nth-child(6), &:nth-child(8), &:nth-child(10) {\n        margin-bottom: 1.5rem;\n\n        &:after {\n          content: \"\";\n          height: 1px;\n          width: 50%;\n          background: var(--black1);\n          display: flex;\n          margin-left: 25%;\n          position: relative;\n          top: 0.75rem;\n        }\n      }\n\n      & > .nav-link {\n        //padding: 0 1rem;\n        height: 35px;\n        width: 35px;\n        justify-content: center;\n        transition: all .15s ease;\n\n        &.active {\n          //margin: 0 0.5rem 0 0.75rem;\n        }\n\n        & > span {\n          opacity: 0;\n          display: none;\n        }\n      }\n\n\n      .nav-dropdown-items-minimized {\n        display: none;\n        max-height: initial;\n        flex-direction: column;\n        position: absolute;\n        background: var(--white);\n        box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.08), 0px 2px 24px -2px rgba(7, 14, 35, 0.12);\n        border-radius: .5rem;\n        min-width: 244px;\n        white-space: nowrap;\n        left: 60px;\n        z-index: 6;\n        padding: .5rem;\n\n        @media (max-height: 900px) {\n          top: 50% !important;\n          transform: translateY(-50%) !important;\n        }\n\n        &.open {\n          display: flex;\n        }\n\n        .nav-item-title {\n          padding: 1rem;\n          padding-top: .5rem;\n          color: var(--black9);\n          font-style: normal;\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 19px;\n        }\n\n        .nav-link {\n          padding: .5rem;\n          margin: 0;\n\n          &:hover {\n            background: var(--black1);\n          }\n        }\n      }\n\n      .nav-dropdown-items {\n        display: none;\n      }\n\n      &.nav-dropdown {\n        .nav-dropdown-items-minimized {\n          display: flex;\n        }\n      }\n    }\n\n  }\n\n}\n\n\n.sidebar-container.minimized  {\n\n  .nav-dropdown-items-minimized.open {\n    position: fixed;\n  }\n\n};\n\n\n.sidebar-minimized {\n  margin-top: 2rem;\n\n  &.nav-item {\n    width: 100%;\n    padding: 0;\n    position: relative;\n\n    .nav-link {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      padding: 0 1rem 0 .75rem;\n      height: 35px;\n      position: relative;\n      margin: 0 .5rem 0 .75rem;\n      color: var(--black5) !important;\n\n      &:focus {\n        outline: none;\n      }\n\n      + .nav-dropdown-items.open {\n        max-height: 400px;\n      }\n\n      span {\n        margin-left: .5rem;\n        opacity: 1;\n        font-size: 13px;\n        font-weight: 400;\n        transition: opacity .15s ease;\n        color: var(--black5);\n      }\n\n      &.active {\n        position: relative;\n        cursor: pointer;\n        background: var(--black1);\n        border-radius: .5rem;\n\n        span {\n          color: var(--white);\n        }\n      }\n    }\n\n    .nav-dropdown-items-minimized {\n      transition: none !important;\n    };\n\n    .nav-dropdown-items, .nav-dropdown-items-minimized {\n      list-style: none;\n      max-height: 0;\n      padding: 0;\n      overflow: hidden;\n      transition: all .15s linear;\n\n      .nav-item {\n        padding: 0 0;\n        margin-bottom: 0;\n        position: relative;\n        cursor: pointer;\n      }\n\n      .nav-link {\n        font-size: 14px;\n        font-weight: 400;\n        padding: .7rem 0 .7rem 1.25rem;\n        cursor: pointer;\n        border-radius: .5rem !important;\n\n        span {\n          margin-left: .5rem;\n          transition: opacity .15s ease;\n          font-weight: 400;\n        }\n\n        &.active {\n          border-radius: .5rem;\n\n          &:hover {\n            span {\n              color: var(--black9) !important;\n            }\n          }\n\n          span {\n            color: var(--black9) !important;\n          }\n        }\n\n        &:hover {\n          background: var(--black1);\n\n          span {\n            color: var(--black9);\n          }\n        }\n\n      }\n    };\n\n    .nav-dropdown-items-minimized {\n      display: none;\n    }\n  };\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n};\n\n.sidebar.minimized {\n    width: 68px;\n    overflow: auto;\n    height: auto;\n};"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
